import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import IBPlanner from "IBPlanner";
import Evidence from "Evidence";
import Insights from "Insights";
import UnitComments from "UnitComments";
import UnitPlanResources from "UnitPlanResources";
import UnitFlowV2 from "./routes/UnitFlowV2";
export default store => {
  return {
    path: "edit",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "unit-planner" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [
      Insights(store),
      Evidence(store),
      UnitComments(store),
      UnitFlowV2(store),
      UnitPlanResources(store),
      IBPlanner(store),
    ],
  };
};
